import Tick from 'assets/tick.svg?react';
import { useEffect } from 'react';
import { useAuth0 } from '@brighte/passwordless-authenticator';
import { useScrollToTop } from '@hooks';
import { Button } from '@spark-web/button';
import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { useTheme } from '@spark-web/theme';
import { OFFER_ACCEPTED } from '@utils';

function OfferAccepted({ vendor }: { vendor: string }) {
  const { clearCredentials } = useAuth0();

  useScrollToTop();
  const { TITLE, CONTENT, WHAT_HAPPENS_NEXT, BRIGHTE_SUPPORT_LINK } = OFFER_ACCEPTED;

  const theme = useTheme();

  useEffect(() => {
    clearCredentials();
  }, []);

  return (
    <Stack gap="xxlarge" padding="large">
      <Heading level="1">{TITLE}</Heading>
      <Stack paddingTop="large">
        <Text size="large">{CONTENT(vendor)}</Text>
        <Stack margin="xsmall" align="center" padding="xlarge">
          <Tick color={theme.color.foreground.primaryActive} />
        </Stack>
      </Stack>
      <Button tone="neutral" size="large" onClick={() => window.open(BRIGHTE_SUPPORT_LINK, '_blank', 'noopener')}>
        {WHAT_HAPPENS_NEXT}
      </Button>
    </Stack>
  );
}

export default OfferAccepted;
